import { createReducer } from '../../utils/createReducer';
import { CampaignActions, SET_CAMPAIGN_RENDER_STATE } from '../actions/types';
import { CampaignState } from '../types';

/**
 * IMBEE-8954 (T114 §6b) — the campaign render state.
 *
 * The repo has one established funnel for "an async server call drives UI state a component
 * reads": a reducer built with `createReducer`, registered in `combineReducers`, dispatched into
 * from outside React (`store/dispatcher.ts`). The campaign controller uses that funnel rather than
 * a component-level subscription of its own, so `CampaignTeaser` reads its state with
 * `useSelector` exactly like it already reads `themeColor` / `showChat` / `parentUrl`.
 */
const initialState: CampaignState = {
  renderState: { status: 'idle' },
};

const campaignReducer = {
  [SET_CAMPAIGN_RENDER_STATE]: (state: CampaignState, { payload }) => ({ ...state, renderState: payload }),
};

const campaigner = (state: CampaignState = initialState, action: CampaignActions) =>
  createReducer(campaignReducer, state, action);
export default campaigner;
